import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Space, Modal } from 'antd';
import ParseHTML from 'html-react-parser';
import Parser from './Parser';
import { ThemeContext } from '../Context/ThemeContext';
import './Style.css';
import PreviewUpdate from '../Drawer/PreviewArticle';

const { Text, Paragraph } = Typography;

export default function TwitterCard(props) {
  const history = useHistory();

  const [fullView, setFullView] = useState(false);
  const { theme } = useContext(ThemeContext);
  const characterCount = props.item.description.length;
  return (
    <div>
      <Space direction='vertical'>
        <Text
          style={{
            color: theme.content.text,
          }}
          type='secondary'
        >
          {new Date(props.item.createdAt).toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
          })}
        </Text>
        <Paragraph
          onClick={() => {
            setFullView(true);
          }}
          style={{
            color: `${theme.content.text}`,
            fontSize: `20px`,
            cursor: 'pointer',
            transform: 'wrap',
          }}
        >
          {ParseHTML(
            Parser(
              `${
                characterCount > 120
                  ? props.item.description.slice(0, 120).concat('...')
                  : props.item.description
              }`
            )
          )}
          <Text
            style={{
              color: `${theme.content.text}`,
              fontSize: `12px`,
            }}
          >
            {characterCount > 120 && `+${characterCount - 120} more characters`}
          </Text>
        </Paragraph>
      </Space>
      {fullView && (
        <PreviewUpdate
          visible={fullView}
          onClose={() => setFullView(false)}
          item={props.item}
          onAction={() => history.push(`/updates/${props.item.uid}`)}
        />
      )}
    </div>
  );
}
